<section class="py-16 bg-dark-light">
  <div class="container mx-auto px-4">
    <div class="max-w-4xl mx-auto text-center">
      <h2 class="text-3xl md:text-4xl font-bold mb-6 text-light text-shadow-glow">Verantwoord Gokken</h2>
      <p class="text-lg mb-8 text-gray-300">
        Gokken kan verslavend zijn. Wij moedigen verantwoord gokken aan en bieden informatie 
        en hulpbronnen voor wie hulp nodig heeft.
      </p>
      
      <div class="bg-primary/20 border border-primary p-6 rounded-lg mb-8">
        <p class="text-xl font-bold text-primary mb-4">18+ Alleen</p>
        <p class="text-gray-200">
          Deze website is alleen bedoeld voor personen van 18 jaar en ouder. 
          Gok nooit met geld dat u niet kunt missen.
        </p>
      </div>

      <div class="grid md:grid-cols-3 gap-4 mb-8">
        <div class="bg-dark p-6 rounded-lg border border-primary/20">
          <h3 class="font-semibold mb-2 text-light">Stel een Budget Vast</h3>
          <p class="text-sm text-gray-400">Bepaal vooraf hoeveel u kunt uitgeven en houd u eraan.</p>
        </div>
        <div class="bg-dark p-6 rounded-lg border border-primary/20">
          <h3 class="font-semibold mb-2 text-light">Neem Pauzes</h3>
          <p class="text-sm text-gray-400">Gok niet continu. Neem regelmatig tijd om te rusten.</p>
        </div>
        <div class="bg-dark p-6 rounded-lg border border-primary/20">
          <h3 class="font-semibold mb-2 text-light">Zoek Hulp</h3>
          <p class="text-sm text-gray-400">Als u denkt dat u een probleem heeft, zoek dan hulp.</p>
        </div>
      </div>

      <button 
        (click)="goToResponsibleGamblingPage()"
        class="bg-primary text-light px-8 py-3 rounded-lg font-semibold hover:bg-pink-700 transition-all duration-300 shadow-glow transform hover:scale-105"
      >
        Meer Over Verantwoord Gokken
      </button>
    </div>
  </div>
</section>

